//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientRate from '@/components/client/ClientRate'
import ClientTasksList from '@/components/client/ClientTasksList'
import ClientFeedbacks from '@/components/client/ClientFeedbacks'
import AvatarDisplay from '@/components/ui/AvatarDisplay'
import Paper from '@/components/ui/Paper'
import SeoMethods from '@/mixins/SeoMethods'
import ClientName from '@/components/client/ClientName'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ClientProfilePreview',
  components: {
    ClientName,
    ClientRate,
    ClientTasksList,
    ClientFeedbacks,
    AvatarDisplay,
    Paper
  },
  mixins: [SeoMethods],
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      avatarOptions: {
        resize: {
          width: 240,
          height: 240
        }
      }
    }
  },
  head () {
    return this.buildTags(this.profile?.name, this.profile?.about, this.profile?.avatar)
  },
  computed: {
    location () {
      const l = []

      if (this.profile?.location) {
        l.push(this.profile.location)
      }

      if (this.profile?.countryId) {
        const countries = this.$store.state.util.countries
        const country = countries.find(c => c.id === this.profile.countryId)

        if (country) {
          l.push(country.name)
        }
      }

      return l.join(', ')
    },

    /**
     * return profile ID
     * @return {Number}
     */
    id () {
      return this.profile?.id
    },

    about () {
      return this.profile?.about
    },

    avatar () {
      return this.profile?.avatar
    },

    name () {
      return this.profile?.name
    },

    color () {
      return this.profile?.color
    },

    trusted () {
      return this.profile?.trusted
    }
  }
}
